module.exports = require("@agm/core/services/managers/marker-manager");